export default __webpack_public_path__ + "static/media/ic_sign in_16.fa320a73.svg";